define('app/sds/menu/md/sidenav/sds-menu-md-sidenav',["service!selcomm", "$parse", "service!sds-menu", "service!sdc-tile-accent", "template!sds-menu-tiles-items-recurse"], function (SelcommWS, $parse, sdsMenuService, sdcTileAccentService) {
	"use strict";
	function updateMenu(menu) {
		return sdsMenuService.ParseMenu(angular.copy(menu));
	}
	function getMenu(menuId) {
		return sdsMenuService.GetMenu(menuId);
	}
	return {
		// Require specifies controllers to look for
		// These will be bound to your controller on PostLink (After the constructor)
		require: {},
		transclude: true,
		controller: {
			// Bind attributes here
			bind: {
				"menuIdExpr": "@?menuId",
				"menuExpr": "@?menu"
			},
			// Define functions here and default properties that are simple types (not objects or arrays)
			prototype: {

			},
			// Define properties with getter/setters
			properties: {

			},
			// Define the constructor, the parameters here are injected, you must use injection to get any of the following
			// $scope, $element, $attrs, $transclude
			// Also note that controllers from the require property will not exist at this stage and are only added after linking
			constructor: ["$scope", "$element", "$attrs", "$transclude", "$self", function ($scope, $element, $attrs, $transclude, vm) {
				var assignSelected, getMenuFn, splitExpr, expr = ("menuId" in $attrs ? this.menuIdExpr : this.menuExpr), _menu;
				if ("demo" in $attrs) {
					vm.demo = true;
				}
				if ("menuId" in $attrs && "menu" in $attrs) {
					throw new Error('Cannot define both "menuId" and "men".');
				}
				else {
					splitExpr = expr.split(/\s+as\s+/i);
					switch (splitExpr.length) {
						case 1:
							assignSelected = angular.noop;
							break;
						case 2:
							assignSelected = (function (exprFn) {
								return exprFn.assign.bind(exprFn);
							}($parse(splitExpr[0])));
							expr = splitExpr[1];
							break;
						default:
							throw new Error("Invalid expression " + expr);
					}
					expr = $parse(expr).bind(null, $scope.$parent, null);
					if ("menuId" in $attrs) {
						vm.loading = true;
						$scope.$watch(expr, function (menuId) {
							vm.loading = getMenu(menuId).then(function (menu) {
								_menu = menu;
							});
						});
					}
					else {
						var lastExprResult = expr();
						$scope.$watch(expr, function (menu) {
							if (lastExprResult !== menu) {
								_menu = updateMenu(lastExprResult);
							}
						});
						_menu = updateMenu(lastExprResult);
					}
					Object.defineProperty(vm, "menu", {
						enumerable: true,
						get: function getMenuFn() {
							return _menu
						}
					});
					vm.assignSelected = assignSelected;
				}
			}]
		},
		link: ["$scope", "$element", "$attrs", "$controllers", "$transclude", "$self", function ($scope, $element, $attrs, $controllers, $transclude, vm) {

		}]
	}
});
